import { IressStack, IressText } from '@iress-oss/ids-components';
import './ContextualTip.css';

interface ContextualTipProps {
  title: string;
  description: string;
}

/**
 * Contextual tip shown for returning users when no messages are in the conversation.
 * Displays centered in the chat body with a bold title and muted description.
 * Supports line breaks in description using \n (rendered via CSS white-space: pre-line).
 */
export function ContextualTip({ title, description }: Readonly<ContextualTipProps>) {
  return (
    <IressStack gap="spacing.1" className="porter-contextual-tip">
      <IressText
        element="p"
        color="muted"
        textAlign="center"
        className="porter-contextual-tip__title"
      >
        {title}
      </IressText>
      <IressText
        element="p"
        color="muted"
        textAlign="center"
        className="porter-contextual-tip__description"
      >
        {description}
      </IressText>
    </IressStack>
  );
}
